import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import UnloggedAreaLayout from '@/components/unloggedArea/UnloggedAreaLayout.vue';
import UserAreaLayout from '@/components/userArea/UserAreaLayout.vue';
import HotReloadingLoader from '@/components/common/loaders/LoaderHotReloading.vue';
import { computed, nextTick, onBeforeMount, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useAppStore } from '@/stores/app.store';
import AppLoader from '@/components/common/loaders/LoaderApp.vue';
import { useRoute } from 'vue-router';
import { layoutAreaTypes } from '@/types/layoutTypes';
import helpers from '@/helpers';
import Toast from '@/components/common/notifications/Toast.vue';
import { useSmoothAnchors } from "@/composables/useSmoothAnchors";
import { useHotjar } from '@/composables/useHotjar';
import { usePostHog } from '@/composables/usePostHog';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isDebugMode = process.env.NODE_ENV === 'development';
const appStore = useAppStore();
const route = useRoute();
const isTouchDevice = ref(false);

useSmoothAnchors();
useHotjar();
usePostHog();

const componentLayout = computed(() => {
  switch (route?.meta.layout) {
    case layoutAreaTypes.User:
      return UserAreaLayout;
    case layoutAreaTypes.Unlogged:
      return UnloggedAreaLayout;
    default:
      return layoutAreaTypes.Unlogged;
  }
});

const checkTouchDevice = () => {
  isTouchDevice.value = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
};

const onResize = () => {
  checkTouchDevice();
  appStore.isMobile = window.innerWidth <= appStore.mobileBreakpoint;
  if (appStore.isMobile) {
    document?.body?.classList?.toggle('mobile-layout', appStore.isMobile);
    document?.documentElement?.style?.setProperty(
      '--mobile-breakpoint',
      `${appStore.mobileBreakpoint}px`,
    );
  }
};

onBeforeMount(async () => {
  await appStore.fetchCultureSettings();
  await appStore.fetchCustomCssSettings();
  await Promise.all([appStore.fetchSystemSettings(), appStore.fetchConfiguration()]);
});

onMounted(() => {
  onResize();
  window.addEventListener('resize', onResize);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize);
});

watch(
  () => appStore.cultureCode,
  async (newCultureCode) => {
    if (newCultureCode) {
      appStore.dir = helpers.lang.getLangDirectionByLangLocaleCode(appStore.cultureCode);
      helpers.lang.setLagAndDirOnHtmlByLangCode(appStore.cultureCode);
      await appStore.fetchTranslations();
    }
  },
  { deep: true },
);

watch(
  () => appStore.isAppDataFetching,
  async (isAppDataFetching) => {
    if (!isAppDataFetching) {
      await nextTick();
      window.dispatchEvent(new CustomEvent('is-app-data-fetched'));
    }
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    isDebugMode
      ? (_openBlock(), _createBlock(HotReloadingLoader, { key: 0 }))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(AppLoader, null, null, 512), [
      [_vShow, !_unref(appStore).isAppReady]
    ]),
    _createVNode(Toast),
    (_unref(route)?.meta?.layout)
      ? _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(componentLayout.value), { key: 1 }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 512)), [
          [_vShow, _unref(appStore).isAppReady]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: "custom-css-wrapper",
      innerHTML: _unref(appStore)?.customCssSettings
    }, null, 8, _hoisted_1)
  ], 64))
}
}

})